<template>
  <v-container class="component_main px-6 py-0">
    <v-row>
      <v-col cols=6>
        <h1>Evolução de Faturamento</h1>
        <!-- <p>Texto explicativo sobre a tela.</p> -->
      </v-col>
      <v-col class="d-flex justify-end" cols="6">
        <v-btn 
          v-if="userData.UsuarioTradimus && userData.PermissaoAcoes.recebiveis.includes('getextratofaturamento')"
          class="mt-5 ml-4"
          height="31px"
          small
          depressed
          outlined
          color="primary"
          @click="validaForm('getExtratoFaturamento')"
        >Extrato de Envio de Faturamento</v-btn>
        <!-- <v-tooltip v-else center bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            class="mt-5 ml-4"
            height="31px"
            small
            depressed
            outlined
            color="primary"
            v-bind="attrs"
            v-on="on"
            >Extrato de Envio de Faturamento</v-btn>
          </template>
          <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
            Você não possui permissão para executar esta ação.
          </span>
        </v-tooltip> -->
      <!-- </v-col>
      <v-col class="d-flex justify-end" cols="3"> -->
        <v-btn 
          v-if="userData.PermissaoAcoes.recebiveis.includes('getextratolotesconsolidado')"
          class="mt-5 ml-4"
          height="31px"
          small
          depressed
          outlined
          color="primary"
          @click="validaForm('getExtratoLotesConsolidado')"
        >Extrato de lotes consolidados</v-btn>
        <v-tooltip v-else center bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            class="mt-5 ml-4"
            height="31px"
            small
            depressed
            outlined
            color="primary"
            v-bind="attrs"
            v-on="on"
            >Extrato de lotes consolidados</v-btn>
          </template>
          <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
            Você não possui permissão para executar esta ação.
          </span>
        </v-tooltip>
      </v-col>
      <v-col cols=12>
       <EvolucaoFatFilter
          :prestadores="prestadores"
          :operadoras="listOperadora"
          :updateFilter="(formData) => getData(formData)"
          :formatDate="(date) => formatDate(date)"
          :parseDate="(date) => parseDate(date)"
          :validarForm="validarForm"
          :solicitaRelatorio="(formData)=>solicitaRelatorioConfirm(formData)"
          />
      </v-col>
    </v-row>
    <v-row wrap>
      <v-col class="col-xs-12 col-sm-12 col-md-12 py-0 px-4">
        <EvolucaoFatChartBar 
          :dadosGrafico="list"
          :dicionario="legendas"
          :chartId="chartId"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EvolucaoFatChartBar from "@/components/recebiveis/evolucao_faturamento/ChartBar";
import EvolucaoFatFilter from "@/components/recebiveis/evolucao_faturamento/Filter";

export default {
  components: {
    EvolucaoFatChartBar,
    EvolucaoFatFilter
  },
  data() {
    return {
      acaoForm: null,
      chartId: "1",
      filter:{},
      filteredList: [],
      legendas: {
        apresentado: "Apresentado",
        liberado: "Liberado",
        glosado: "Glosado",
        aconciliar: "À conciliar"
      },
      // list:{
      //  datas: [ 'jan/2021',  'fev/2021',  'mar/2021',  'abr/2021', 'mai/2021'],
      //   dados:{
      //     apresentado:  [660.73, 897.66, 1226.9, 789, 999],
      //     liberado: [600, 893.9, 792.9, 600, 698],
      //     glosado: [145.73, 293.9, 329.9, 123, 100],
      //     aconciliar: [120.73, 83.9, 39.9, 456, 2]
      //   }
      // },
      list:{
        periodo: [],
        grafico:{
          apresentado:  [],
          liberado: [],
          glosado: [],
          aconciliar: []
        }
      },
      prestadores: [],
      validarForm: false
    };
  },
  watch: {
    grupoEconomico:{
      deep: true,
      handler() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
      }
    },
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
      userData: (state) => state.userData.userData,
    }),
  },
mounted(){
    let opts = {
          grupo_economico: this.grupoEconomico,
          limitar: false,
          modulo_operadora: "recebiveis",
          prestador_ids: []
        }
    this.getOperadoras(opts)
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
  },
  methods: {
    ...mapActions('permissions', [
      "getOperadoras",
    ]),
    
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    getData(filter) {
      this.filter = filter;
        var data = {
          query: 
          [{
            "Modulo": "recebiveis",
            "Acao": "getevolucaofaturamento",
            "Payload":  {...filter, grupo_economico: this.grupoEconomico,}
          }]
        };

      this.$store.dispatch("request/doRequest", data).then(response => {
         if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return
        }
        this.chartId = new Date().getTime().toString();
        this.list.periodo = response.periodo
        this.list.grafico  = response.grafico
        })
    },
    solicitaRelatorioConfirm(filter) {
      let titulo =  this.acaoForm.toLowerCase() == "getextratolotesconsolidado" ? "Solicitar extrato de lotes consolidado com o filtro:": "Solicitar extrato de envio de faturamento com o filtro:";
      this.filter = filter
      let prestador = this.filter.prestador_id.length?this.filter.prestador_id.map( prest => this.prestadores.find(p=>p.id == prest).prest_nome).join(', ')+'.' : 'Todos'
      let operadora = this.filter.operadora_ans_id.length?this.filter.operadora_ans_id.map( oper => this.listOperadora.find(p=>p.id == oper).oper_nome).join(', ')+'.' : 'Todos'
      let tipoData = this.filter.tipo_data == "dt_faturamento" ? 'Cobrança' : 'Vencimento'
      let dataInicial = this.formatDate(this.filter.data_inicio)
      let dataFinal = this.formatDate(this.filter.data_fim)
      let paramModal = {
        type: "info",
        title: titulo,
        message: `
          Prestador(es): <strong>${prestador}</strong><br>
          Operadora(s): <strong>${operadora}</strong><br>
          Selecionar pela data de <strong>${tipoData}</strong><br>
          Período de <strong>${dataInicial}</strong> até <strong>${dataFinal}</strong>
          `,
        callback: () => this.solicitaRelatorio(this.filter, this.acaoForm),
        btConfirm: { name: "Solicitar", show: true },
        btCancel: { name: "Cancelar", show: true },
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    solicitaRelatorio(formData, acao) {
      let opts = {}
      if(formData == null){
        opts = Object.assign(this.pagination, { grupoEconomico: this.grupoEconomico, limitar: false }, this.filter)
        this.solicitaRelatorio(opts).then(()=>this.showList = true)
        return
      }
      formData.grupo_economico = this.grupoEconomico

      //let acao ="getExtratoLotesConsolidado"
      let payload = formData

      var data = {
        query: 
        [{
          "Modulo": "recebiveis",
          "Acao": acao,
          "Payload": payload
        }]
      };

      this.$store.dispatch("request/doRequest", data).then((response) => {
        //this.acaoForm = null
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: response.warning? "warning":"success",
          title: "Atenção!",
          message: response.mensagem,
          callback: () => {},
          btConfirm: { name: "Ok", show: true },

        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    validaForm(acao){
      this.acaoForm = acao
      this.validarForm = true
      this.$nextTick(()=>this.validarForm = false)
    }
  }
};
</script>
<style>
</style>